<article>
  <ng-container *ngIf="this.showRanking()">
    <section>
      <span class="title"> {{ 'user.ranking.position.title' | translate }} </span>

      <div class="content">
        <span> {{currentPosition}} </span>
        <span> / {{totalPosition}}</span>
      </div>

      <opac-button type="text" (click)="openPositionModal.emit($event)">
        {{ 'user.ranking.viewDetails' | translate }}
        <opac-icon slot="end" [icon]="'navigate_next'"></opac-icon>
      </opac-button>
    </section>

    <opac-divider [vertical]="vertical()"></opac-divider>
  </ng-container>

  <section>
    <span class="title"> {{ scoreLabel() | translate }} </span>

    <div class="content">
      <span> {{currentPoints}} </span>
    </div>
    <opac-button type="text" (click)="openScoreModal.emit($event)">
      {{ 'user.ranking.viewDetails' | translate }}
      <opac-icon slot="end" [icon]="'navigate_next'"></opac-icon>
    </opac-button>
  </section>

  <div class="background">
    <ng-content select="[slot='background']"></ng-content>
  </div>
</article>
